import { DEFAULT_COVER_ICON, DEFAULT_COVER_ICON_IMAGE } from "@/constants/mixtapeCover";

type CoverIconDisplay =
  | { type: "image"; value: string }
  | { type: "text"; value: string };

const IMAGE_ICON_PATTERN = /\.(png|jpe?g|gif|svg)$/i;

export const getCoverIconDisplay = (icon?: string | null): CoverIconDisplay => {
  if (!icon || icon === DEFAULT_COVER_ICON) {
    return { type: "image", value: DEFAULT_COVER_ICON_IMAGE };
  }

  if (
    IMAGE_ICON_PATTERN.test(icon) ||
    icon.startsWith("/") ||
    icon.startsWith("http")
  ) {
    return { type: "image", value: icon };
  }

  return { type: "text", value: icon };
};
